<template>
  <div
    v-if="onlyChangeDisplay || _modal || noClose"
    :style="[onlyChangeDisplay && !_modal && !noClose ? 'display: none' : '']"
  >
    <div class="_modal_1some_1" role="dialog">
      <div class="_overlay_1some_5" @click.self="_modal = false;" id="modal-overlay">
        <div class="_panel_1some_17">
          <div class="_card_hl826_1 _card_1some_26">
            <div class="_header_hl826_12">
              <div class="_title_hl826_18">{{ title }}</div>
              <div v-if="!noClose" class="_extra_hl826_8">
                <Button
                  :class="'_icon-button_19fmc_1'"
                  :color="'text'"
                  :size="'medium'"
                  :type="'button'"
                  @click="_modal = false"
                >
                  <svg
                    class="svg-component _icon_1some_38"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 17L17 7"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    ></path>
                    <path
                      d="M7.00024 7.00024L17 17"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.5"
                    ></path>
                  </svg>
                </Button>
              </div>
            </div>
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from './buttons/AbanButton.vue'

export default {
  data() {
    return {
      _modal: false
    }
  },
  emits: ['update:modal'],
  props: {
    modal: {
      required: true
    },
    title: {
      default: ''
    },
    onlyChangeDisplay: {
      default: false
    },
    noClose: {
      default: false
    }
  },
  components: {
    Button
  },
  watch: {
    _modal: function () {
      this.$emit('update:modal', this._modal)
    },
    modal: function () {
      this._modal = this.modal
    }
  },
  created() {
    this._modal = this.modal
  }
}
</script>
